import { extend } from 'underscore';
import { getHeaderStyles, getApplyFormStyles, getIconStyles, getFeedbackModalStyles } from '@bingads-webui-campaign-react/recommendation-shared-styles';

const cardWidth = 447;

export const getStyles = ({
  palette = {
    white: '#FFFFFF',
    themePrimary: '#0078D4',
  },
}) => ({
  '@global': extend(
    Object.assign(getApplyFormStyles({ palette })),
    Object.assign(getFeedbackModalStyles({ palette }))
  ),
  carouselContainer: {
    width: cardWidth,
    height: 193,
    marginTop: 23,
    marginRight: 16,
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',

    '& .carousel-wrapper': {
      display: 'flex',
      '& .carousel .item': {
        width: cardWidth,

        '& .recommendation-summary-header': {
          padding: '8px 13px 8px 16px',
          borderBottom: '1px solid #F3F2F1',

          ...getHeaderStyles({ palette }),
          ...getIconStyles(),
        },
        '& .recommendation-summary-footer': {
          paddingLeft: '16px',
          '& button.btn-primary': {
            marginRight: '8px',
          },
          '& button.btn': {
            paddingLeft: '12px',
            paddingRight: '12px',
            fontSize: '12px',
          },
        },
      },
      '& .carousel-control': {
        textShadow: 'none',
        background: 'none',
        cursor: 'default',
        top: 'auto',
        bottom: '10px',
        '&:focus:after': {
          border: 'none',
        },
        '&.left': {
          color: palette.themePrimary,
          right: '36px',
          left: 'auto',
        },
        '&.right': {
          color: palette.themePrimary,
          right: '13px',
        },
        '& .iconba': {
          cursor: 'pointer',

          '&.disabled': {
            cursor: 'default',
            color: '#C8C6C4',
          },
        },
      },
    },
  },
  cardContent: {
    padding: '0px 16px',
    height: '106px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  description: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
  },
  tooTip: {
    borderBottom: `1px dashed ${palette.themePrimary}`,
    cursor: 'default',
    display: 'inline-block',
    color: '#666666',
  },
  carouselIndex: {
    position: 'absolute',
    right: '60px',
    bottom: '3px',
  },
});
